import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HistoryPage } from "../../dto/History/BusinessHistoryDto";
import { HistoryCard } from "../../viewModels/History/BusinessHistoryModel";
import { HistoryRootRequest } from "../../api/apiServices/backOffice/controllers/businessHistory/businessHistory.requestsDto";
export type Query<T> = { key: string; requestId: string; request: T };
export type LoadState<T> = { requestId: string; loading: boolean; error?: string; data?: T };
type Result<T> = { key: string; requestId: string; data: T };
type Failure = { key: string; requestId: string; error: string };
type HistoryState = {
  cards: Record<string, LoadState<HistoryPage<HistoryCard>>>;
};
const initialState: HistoryState = { cards: {} };
const slice = createSlice({
  name: "businessHistory",
  initialState,
  reducers: {
    loadCards(state, { payload }: PayloadAction<Query<HistoryRootRequest>>) {
      state.cards[payload.key] = { requestId: payload.requestId, loading: true };
    },
    loadCardsSuccess(state, { payload }: PayloadAction<Result<HistoryPage<HistoryCard>>>) {
      if (state.cards[payload.key]?.requestId === payload.requestId)
        state.cards[payload.key] = { requestId: payload.requestId, data: payload.data, loading: false };
    },
    loadCardsReject(state, { payload }: PayloadAction<Failure>) {
      if (state.cards[payload.key]?.requestId === payload.requestId)
        state.cards[payload.key] = { requestId: payload.requestId, loading: false, error: payload.error };
    },
    clear(state, { payload }: PayloadAction<string>) {
      for (const key of Object.keys(state.cards)) if (key === payload || key.startsWith(payload + "/")) delete state.cards[key];
    },
  },
});
export default slice;
